import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import {
    GET_INVENTORY_DATA,
    GET_INVENTORY_DATA_SUCCESS,
    GET_INVENTORY_DATA_FAILURE,
    SET_INVENTORY_ITEMS_DETAILS,
} from '../actions';

const initialState = {
    loading: false,
    totalRecords: 0,
    checkedItems: [],
    sortParam:''
};

const InventoryReturnReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_INVENTORY_DATA:
            return {
                ...state,
                loading: true,
                totalRecords: 0,
            };
        case GET_INVENTORY_DATA_SUCCESS:
            return {
                ...state,
                loading: false,
                inventoryData: action.payload.inventoryListDTO,
                totalResults: action.payload.itemsNumber,
                sortParam:action.payload.sortCode
            };
        case GET_INVENTORY_DATA_FAILURE:
            return {
                ...state,
                loading: false,
            };
        case SET_INVENTORY_ITEMS_DETAILS:
            return {
                ...state,
                checkedItems: action.payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default persistReducer(
    {
        key: 'inventoryReturnKey',
        storage: storage,
        //transforms: [SetTransform],
    },
    InventoryReturnReducer
);
